// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import LoginLogo from './images/loginLogo.png';

const styles = theme => ({
  root : {
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left : 0,
    backgroundImage: theme.brandingColors.loginGradient,    
    backgroundColor: theme.palette.secondary.main,    
    display : 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialog: {
    background: theme.palette.primary.main,
    borderRadius: 25,
    textAlign: 'center',
    padding: 50,
    width: 320,
  },
  content: {
    color: 'white',
    marginTop: 25,
    fontSize: '1.25rem',
  },
  
});

class BrowserList extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.dialog}>
          <img alt='' src={LoginLogo}/>
          <div className={classes.content}>
            <p>This application requires features not available on this browser.</p>
            <p><u>Supported Windows Browsers</u></p>
            <p>Microsoft Edge<br/>
              Google Chrome<br/>
              Mozilla Firefox</p>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BrowserList);

